import $ from 'jquery';
import Viewport from './Viewport';

export default class MemberBtn {
  constructor(element, $mobileDest, $desktopDest) {
    this.$element = $(element);
    this.$mobileDest = $mobileDest;
    this.$desktopDest = $desktopDest;
    this.listen();
    this.change();
  }

  listen() {
    Viewport.onChange(this.change.bind(this));
  }

  change() {
    if (Viewport.mobileState) {
      this.$element.prependTo(this.$mobileDest);
    } else {
      this.$element.appendTo(this.$desktopDest);
    }
  }
}
